import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = {
  key: 0,
  class: "d-block col-md-2 ps-0"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "d-block col-md-2 pe-0"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

import { computed, onMounted, watch, nextTick, PropType } from "vue";
import Monitoring from "@/guiide/ts/monitoring/monitoring";
import SubSection from "../common/SubSection.vue";
import { useStore } from "vuex";
import { AdviserResponse } from "@/guiide/ts/response/adviserResponse";
import { app } from "@/guiide/ts/app";
import AdviserListDisplayMode from "@/guiide/ts/adviserListDisplayMode";


export default /*@__PURE__*/_defineComponent({
  __name: 'AdvisorsList',
  props: {
    alwaysDisplay: { type: Boolean, default: false, required: false },
    adviserKeysFilter: { type: Array as PropType<Array<string>>, default: () => [], required: false }
},
  setup(__props) {

const props = __props;

const store = useStore();
const display = computed<boolean>(() => props.alwaysDisplay || store.state.configuration.finishDisplaysAdvisors);
const advisors = computed<Array<AdviserResponse>>(() => {
    const advisers: Array<AdviserResponse> = store.state.advisers;

    if (props.adviserKeysFilter.length == 0) {
        return advisers;
    }

    return advisers.filter(a => props.adviserKeysFilter.some(k => k == a.key));
});
const title = computed<string>(() => store.state.configuration?.adviserListTitle ?? "");
const showLogoAndButton = computed<boolean>(() => {
    return (store.state.configuration?.adviserListDisplayMode ?? AdviserListDisplayMode.Full) == AdviserListDisplayMode.Full;
});
const descClasses = computed<string>(() => showLogoAndButton.value ? "col-md-8" : "col-md-12");

onMounted(() => {
    if (advisors.value == null || advisors.value.length == 0) {
        app.getAdvisers();
    }
})

watch(
    advisors,
    () => {
        nextTick(() => {
            document.querySelectorAll('[data-redirect]').forEach(button => {
                button.removeEventListener('click', handleRedirect);
                button.addEventListener('click', handleRedirect);
            });
        });
    },
    { immediate: true });

const handleRedirect = (event) => {
  const url = event.currentTarget.dataset.redirect;
  const appEvent = event.currentTarget.dataset.appEvent;

  if (appEvent) {
    Monitoring.trackEvent(appEvent, {});
  }

  if (url) {
    window.location = url;
  }
};

function getDescription(adviser: AdviserResponse): Array<string> {
    if (showLogoAndButton.value) {
        return adviser.description;
    } else {
        return adviser.advertDescription;
    }
}

function hasMoreDetails(advisorKey: string) {
    const advisor = advisors.value.find(a => a.key == advisorKey);
    return advisor.moreDetailsUrl.length > 0;
}

function onFindAdviceClick(advisorKey: string) {
    const advisor = advisors.value.find(a => a.key == advisorKey);
    const potsValue = store.state.retiree?.pensionPots.presentValue ?? 0;
    Monitoring.gaEvent(advisor.key, potsValue);
    window.open(advisor.findAdviceUrl, "_blank");
}

function onMoreDetailsClick(advisorKey: string) {
    const advisor = advisors.value.find(a => a.key == advisorKey);
    window.open(advisor.moreDetailsUrl, "_blank");
}

return (_ctx: any,_cache: any) => {
  return (display.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SubSection, {
            title: title.value,
            showHelp: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(advisors.value, (advisor, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `advisor${i}`,
                    class: "row pt-3 row-divider"
                  }, [
                    (showLogoAndButton.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("img", {
                            src: advisor.image,
                            class: "w-100",
                            alt: advisor.name
                          }, null, 8, _hoisted_5)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["d-block pt-4 pt-md-0 px-0 ps-md-4", descClasses.value])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDescription(advisor), (desc, j) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: `desc${j}`,
                          innerHTML: desc
                        }, null, 8, _hoisted_6))
                      }), 128))
                    ], 2),
                    (showLogoAndButton.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (hasMoreDetails(advisor.key))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-primary btn-sm float-end ms-2 mt-2",
                                onClick: ($event: any) => (onMoreDetailsClick(advisor.key))
                              }, "More details", 8, _hoisted_8))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "btn btn-primary btn-sm float-end ms-2 mt-2",
                            onClick: ($event: any) => (onFindAdviceClick(advisor.key))
                          }, "Find advice", 8, _hoisted_9)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})